import React from 'react';

// Used in the error panel
// for tabulating errors
const AccordionMenu = ({ accordionContents }) => {
  return (
    <>
      {Object.entries(accordionContents).map(
        bellow =>
          bellow[1] && (
            <details key={bellow[0]}>
              <summary>{bellow[1].summary}</summary>
              {bellow[1].panelContents}
            </details>
          ),
      )}
    </>
  );
};

export default AccordionMenu;
